import React from 'react'
import './frozen.scss'


const Frozen = () => {
  return (
    <div className="__fw" style={{ paddingBottom: "10px", paddingTop: "10px" }}>
      <div style={{ paddingBottom: "10px", paddingTop: "10px" }}>
        <strong
          style={{
            textTransform: "uppercase",
            letterSpacing: "3px",
            fontWeight: "400",
          }}
        >
          Now Available On{" "}
        </strong>
      </div>
      <div className="logo_wrp">
        <img src={require("../../img/noon_logo.jpg")} alt="" />
        {/* <img src={require("../../img/logo.png")} alt="" /> */}
      </div>
      <div className="bd-grid ">
        <a
          href="
https://minutes.noon.com/uae-en/now-product/Z0B2AE8D4D3FA8274632CZ-1/"
          class="card__icon"
        >
          <article class="card">
            <div class="card__img">
              <img src={require("../../img/01.avif")} alt="" />
            </div>

            <div class="card__precis">
              <div
                style={{
                  width: "100%",
                  alignItems: "center",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {/* <span class="card__preci card__preci--before">$990.00</span> */}
                <small style={{ fontSize: "13px" }}>Frozen Rhutab Dates</small>
                <span class="card__preci card__preci--now">Milk Chocolate</span>
              </div>
              <a
                href="https://minutes.noon.com/uae-en/now-product/Z4027E85DFB1A9CDF737DZ-1/
"
                class="card__icon"
              >
                <ion-icon name="cart-outline"></ion-icon>
              </a>
            </div>
          </article>
        </a>
        <a
          href="
https://minutes.noon.com/uae-en/now-product/Z4027E85DFB1A9CDF737DZ-1/"
          class="card__icon"
        >
          <article class="card">
            <div class="card__img">
              <img src={require("../../img/02.avif")} alt="" />
            </div>

            <div class="card__precis">
              <div
                style={{
                  width: "100%",
                  alignItems: "center",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <small style={{ fontSize: "13px" }}>Frozen Rhutab Dates</small>
                <span class="card__preci card__preci--now">Dark Chocolate</span>
              </div>
            </div>
          </article>
        </a>
      </div>
    </div>
  );
}

export default Frozen
